import React, { Component } from 'react';
import '../App.css';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class ErrorPage extends Component {

    componentDidMount() {
        const { t } = this.props;
        document.title = t("titleappname") + t("title_error")
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                {t("errormsggeneric")}
            </div>
        )
    }
}

export default withRouter(withTranslation()(ErrorPage), ErrorPage);